import React, { useState } from 'react'
import { candidatsData } from '../candidats.yml'
import styles from './candidats-cards.m.scss'
import { useHistory } from 'react-router-dom'

const c = [1, 2, 3, 4, 5]
console.log(c)

export const CandidatsCards = () => {
  const history = useHistory()
  const [candidats, setCandidats] = useState(
    candidatsData.sort(() => 0.5 - Math.random())
  )

  return (
    <div className={styles.container}>
      {candidats.map((candidat: Candidat) => (
        <div
          className={styles.card}
          key={`candidat-${candidat.id}`}
          onClick={() => {
            history.replace(`${candidat.id}`)
          }}
        >
          <div
            className={styles.portrait}
            style={{
              backgroundImage: `url(${require(`./candidats-pictures/${candidat.id}.jpg`)})`
            }}
          >
            <div className={styles.groupe}>
              <i
                style={{ backgroundColor: `#${candidat.groupe.couleur}` }}
                className={styles.couleurParti}
              />{' '}
              {candidat.groupe.abbr}
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.name}>{candidat.nom}</div>
            <div className={styles.infos}>
              <div>
                {candidat.naissance} ans, {candidat.residence}
              </div>
              <div>{candidat.groupe.nom}</div>
            </div>
            <div className={styles.quote}>{candidat.citation}</div>
          </div>
          <div className={styles.link}>
            <u>Voir la vidéo</u>
          </div>
        </div>
      ))}
    </div>
  )
}
